import {
  DOCUMENT_LIST_STARTED,
  DOCUMENT_LIST_COMPLETED,
  DOCUMENT_LIST_FAILED,
  DOCUMENT_CLEAR,
  DOCUMENT_TYPES,
  COUNER_TYPES,
  YEARS_TYPES,
  FILES_LIST_STARTED,
  FILES_LIST_COMPLETED,
  FILES_LIST_FAILED,
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { BACKEND_URL_PREFIX, itemsOnPage } from "../utils/const";
import { checkAndUpdateToken } from "./auth";

// Условия отбора перечня: GET /edudocs.
// Пустое значение отбор НЕ выключает — бэк подставляет его в запрос как есть
// (для числовых параметров это 500), поэтому пустой параметр не передаётся вовсе.
// Ноль вместо «Все» тоже не годится: сравнение идёт по идентификатору справочника.
// fio и number уходят в ILIKE как есть — символы % для поиска по части значения
// добавляет клиент.
const buildQuery = (filters = {}, page = 0) => {
  const { cat, type, year, from, to, fio, number } = filters;
  const query = new URLSearchParams();

  if (cat) query.append('edudocownertype', cat);
  if (type) query.append('doctype', type);
  if (year) query.append('year', year);
  if (from) query.append('datefrom', from);
  if (to) query.append('dateto', to);
  if (fio && fio.trim()) query.append('fio', `%${fio.trim()}%`);
  if (number && String(number).trim()) query.append('number', `%${String(number).trim()}%`);

  // paginateFrom учитывается только вместе с maxResults
  query.append('maxResults', itemsOnPage);
  query.append('paginateFrom', page * itemsOnPage);

  return query.toString();
};

// Тело перечня — {count, edudoctypeslist}: массив и счётчик разбираются здесь,
// в стор ложатся отдельными полями
export const getDocsList = (page = 0, filters = {}) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: DOCUMENT_LIST_STARTED });

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/edudocs?${buildQuery(filters, page)}`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: DOCUMENT_LIST_COMPLETED,
        list: result.edudoctypeslist || [],
        count: result.count || 0,
      });
    } else {
      // отказ сервера не должен выглядеть как «данных нет» — код уходит в стор
      dispatch({ type: DOCUMENT_LIST_FAILED, errorStatus: response.status });
    }
  } catch {
    dispatch({ type: DOCUMENT_LIST_FAILED, errorStatus: 0 });
  }
};

export const clearDocuments = () => ({ type: DOCUMENT_CLEAR });

// Справочник видов документа: did / docname
export const getDocTypes = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/edudoctypes`,
      buildDefaultHeaders(getState)
    );
    const result = response.ok ? await response.json() : [];
    dispatch({ type: DOCUMENT_TYPES, payload: Array.isArray(result) ? result : [] });
  } catch {
    dispatch({ type: DOCUMENT_TYPES, payload: [] });
  }
};

// Справочник категорий получателя: oid / owner_kind
export const getCownerTypes = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/edudocownertypes`,
      buildDefaultHeaders(getState)
    );
    const result = response.ok ? await response.json() : [];
    dispatch({ type: COUNER_TYPES, payload: Array.isArray(result) ? result : [] });
  } catch {
    dispatch({ type: COUNER_TYPES, payload: [] });
  }
};

// Общий справочник учебных годов: {schoolYear: [{xp_key, name}]}
export const getYearsTypes = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/scy`,
      buildDefaultHeaders(getState)
    );
    const result = response.ok ? await response.json() : null;
    dispatch({ type: YEARS_TYPES, payload: result?.schoolYear || [] });
  } catch {
    dispatch({ type: YEARS_TYPES, payload: [] });
  }
};

// Файлы документа для карточки: GET /edudocs/{mid}/{djid}/files.
// Отдельного метода на один документ нет — остальные сведения карточка берёт
// из строки перечня.
export const getFilesList = (mid, djid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: FILES_LIST_STARTED });

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/edudocs/${mid}/${djid}/files`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: FILES_LIST_COMPLETED, payload: Array.isArray(result) ? result : [] });
    } else {
      dispatch({ type: FILES_LIST_FAILED, errorStatus: response.status });
    }
  } catch {
    dispatch({ type: FILES_LIST_FAILED, errorStatus: 0 });
  }
};
